// extracted by mini-css-extract-plugin
module.exports = {"root":"CreatorDetailButton_root__SF-7f","view":"CreatorDetailButton_view__V1gPp","title":"CreatorDetailButton_title__xhoam","table":"CreatorDetailButton_table__2C3ke"};